import { capitalizeFirstLetter } from 'src/lib/Utils/helpers/strings';
import { TabsPropsType } from './TabsRow';

export type TabPropsType = Pick<TabsPropsType, 'currentTab' | 'handleTabSelect'> & {
  categoryName: string;
};

const Tab = ({ currentTab, categoryName, handleTabSelect }: TabPropsType) => {
  return (
    <button
      className={`grow ${
        categoryName === currentTab
          ? 'border-b-teal-dark border-b-2 font-bold text-teal-darker'
          : ''
      }`}
      data-testid={`${categoryName}-tab`}
      onClick={() => handleTabSelect(categoryName)}
    >{`${capitalizeFirstLetter(categoryName)}`}</button>
  );
};

export default Tab;
